<div class="editor-sideber">
    <div *ngIf="isCollapsed" class="expand-mode flex flex-col">
        <form [formGroup]="inputForm" class="top-search flex flex-col">
            <h2>Actions Library</h2>
            <mat-form-field appearance="outline" class="w-p-100">
                <mat-label>Search</mat-label>
                <input formControlName="searchText" matInput placeholder="Search..." rows="1" type="text" />
            </mat-form-field>
        </form>
        <div class="flex flex-col justify-start items-start mat-accordion-container">
            <mat-accordion *ngFor="let nodeGroup of viewNodeGroups; let i = index">
                <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false"
                    [expanded]="true">
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            {{nodeGroup.title}}
                        </mat-panel-title>

                    </mat-expansion-panel-header>
                    <div class="p-20 full-grow-no-shrink-no-basis">
                        <div class="expansion-panel-subtitle">{{nodeGroup.description}}</div>
                        <div cdkDropList [cdkDropListData]="nodeGroup.nodes" class="example-list">
                            <div (mousedown)="onClickedNodeItem(node)" (click)="showNodeDescriptionDialog(node)"
                                *ngFor="let node of nodeGroup.nodes; let i = index"
                                [cdkDragData]="{dragType: 'External', dataItem: node}" cdkDrag class="example-box">
                                <i class="fa-solid fa-grip-dots-vertical"></i>
                                <div class="icon-container">
                                    <i class="{{node?.fieldValues?.Icon ? node?.fieldValues?.Icon : ''}}"></i>
                                </div>
                                <div class="content flex flex-col">
                                    <h3>{{node.title}}</h3>
                                  <p *ngIf="nodeGroup?.title === 'General'">{{ node?.description }}</p>

                                </div>
                            </div>
                        </div>
                    </div>
                </mat-expansion-panel>
            </mat-accordion>
        </div>
    </div>
</div>

<!--
<div class="editor-sideber" *ngIf="!enableQnrFieldImport">
    <div *ngIf="isCollapsed" class="expand-mode flex flex-col">
        <form [formGroup]="inputForm" class="top-search flex flex-col">
            <h2>Actions Library</h2>
            <mat-form-field appearance="outline" class="w-p-100">
                <mat-label>Search</mat-label>
                <input formControlName="searchText" matInput placeholder="Search..." rows="1" type="text" />
            </mat-form-field>
        </form>
        <div class="flex flex-col justify-start items-start mat-accordion-container">
            <mat-accordion *ngFor="let nodeGroup of viewNodeGroups; let i = index">
                <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false"
                    [expanded]="isOpen[i]">
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            {{nodeGroup.title}}
                        </mat-panel-title>

                    </mat-expansion-panel-header>
                    <div class="p-20 full-grow-no-shrink-no-basis">
                        <div class="expansion-panel-subtitle">{{nodeGroup.description}}</div>
                        <div cdkDropList [cdkDropListData]="nodeGroup.nodes" class="example-list">
                            <div (mousedown)="onClickedNodeItem(node)" (click)="showNodeDescriptionDialog(node)"
                                *ngFor="let node of nodeGroup.nodes; let i = index"
                                [cdkDragData]="{dragType: 'External', dataItem: node}" cdkDrag class="example-box">
                                <i class="fa-solid fa-grip-dots-vertical"></i>
                                <div class="icon-container">
                                    <i class="{{node?.fieldValues?.Icon ? node?.fieldValues?.Icon : ''}}"></i>
                                </div>
                                <div class="flex flex-col content">
                                    <h3>{{node.title}}</h3>
                                    <p>{{node.description}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </mat-expansion-panel>
            </mat-accordion>
        </div>
    </div>
</div>-->
